import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EMDSearchSubHeaderComponent } from './emd-search-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [EMDSearchSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [EMDSearchSubHeaderComponent],
})
export class EMDSearchSubHeaderModule {}
